import React from 'react';
import Add from '@mui/icons-material//Add';
import { Divider } from '@mui/material';
import { NEW_FIRM_SLUG } from 'common/constants/sidebar';
import { AddFirmItemProps } from './AddFirmItem.props';
import { StyledAddFirmMenuItem } from '../BottomMenuItems/BottomMenuItems.styles';

const AddFirmItem = ({ handleAddFirm, classes, onKeyDown }: AddFirmItemProps) => (
  <div key={NEW_FIRM_SLUG}>
    <Divider className={classes?.divider} />
    <StyledAddFirmMenuItem
      key={NEW_FIRM_SLUG}
      component="button"
      data-sidebar-firm-option="true"
      onClick={handleAddFirm}
      onKeyDown={onKeyDown}
      className={`
            sidebar-bottom__dropdown-item
            sidebar-bottom__dropdown-item-${NEW_FIRM_SLUG}
            ${classes?.menuItem}
        `}>
      <Add className={classes?.menuItemIcon} />
      Add Firm
    </StyledAddFirmMenuItem>
  </div>
);

export default AddFirmItem;
